import { baseUrl, bosnianBaseUrl, getResource, postResource } from './Services';
import store from '../Store/index';

export function getCurrentLang() {
  const state = store.getState();
  const { language } = state.lang;
  return language;
}

export function getBaseURL() {
  const state = store.getState();
  const { language } = state.lang;
  return language === 'hr' ? bosnianBaseUrl : baseUrl;
}

export function getTermsAndConditions(onSuccess, onFail) {
  const lang = getCurrentLang();
  const region = lang === 'hr' ? 'bs' : 'eg';
  const path = `api/User/GetTermsAndConditions?forScarption=true&language=${lang}`;
  getResource(path, onSuccess, onFail, region);
}

export function contactUs(data, onSuccess, onFail) {
  const lang = getCurrentLang();
  const region = lang === 'hr' ? 'bs' : 'eg';
  const path = `api/ContactUs?language=${lang}`;
  postResource(path, data, onSuccess, onFail, region);
}

export function getStores(onSuccess, onFail) {
  const lang = getCurrentLang();
  const region = lang === 'hr' ? 'bs' : 'eg';
  const path = `api/Admin/GetActiveStores?language=${lang}`;
  getResource(path, onSuccess, onFail, region);
}

export function getSupplyTypes(onSuccess, onFail) {
  const lang = getCurrentLang();
  const region = lang === 'hr' ? 'bs' : 'eg';
  const path = `api/ScrapperSupplyType/ForUser?language=${lang}`;
  getResource(path, onSuccess, onFail, region);
}

export function claimInviteFriendOffer(data, onSuccess, onFail) {
  const lang = getCurrentLang();
  const { payload, region } = data;
  const path = `api/InviteFriend?language=${lang}`;
  postResource(path, payload, onSuccess, onFail, region);
}

export function getBonus(onSuccess, onFail) {
  const lang = getCurrentLang();
  const region = lang === 'hr' ? 'bs' : 'eg';
  const path = `api/Setting/AllScrapperSettings?language=${lang}`;
  getResource(path, onSuccess, onFail, region);
}
